export default "__VITE_ASSET__C1Jh7qJT__"